/**
 * 统一权限标记格式，全部收敛为 controller@action
 * 支持：
 * 1. settlementReceivable@add                        -> 原样
 * 2. accident@accident@index（后端三段式 mark）      -> accident@index
 * 3. financial.settlementReceivable.add              -> settlementReceivable@add
 * 4. user.store                                      -> user@store
 */
export function normalizeActionMark(action: string): string {
  const value = String(action || '').trim()
  if (!value) return ''

  // 后端 permission_mark：可能为 controller@action，也可能为 module@controller@action 三段式
  if (value.includes('@')) {
    const parts = value.split('@').filter(Boolean)
    if (parts.length >= 3) return `${parts[parts.length - 2]}@${parts[parts.length - 1]}`
    return parts.join('@')
  }

  // 兼容旧写法：module.controller.action / controller.action
  const parts = value.split('.').filter(Boolean)
  if (parts.length === 3) return `${parts[1]}@${parts[2]}`
  if (parts.length === 2) return `${parts[0]}@${parts[1]}`

  return value
}
